import React, { useState } from 'react';
import './AddModalVehicles.css';

const AddModalVehicles = ({ isOpen, onClose, onAddDriver }) => {
  const [certificateFile, setCertificateFile] = useState(null);
  const [certificatePreview, setCertificatePreview] = useState(null);

  if (!isOpen) return null;

  const handleCertificateChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCertificateFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setCertificatePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setCertificateFile(null);
      setCertificatePreview(null);
    }
  };

  const handleAddDriver = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('full_name', event.target.full_name.value);
    formData.append('car_number', event.target['car-number'].value);
    formData.append('certificate', certificateFile);
    onAddDriver(formData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Добавить транспортное средство</h2>
        <form onSubmit={handleAddDriver}>
          <div>
            <label htmlFor="full_name">Марка:</label>
            <input type="text" id="full_name" name="full_name" required />
          </div>
          <div>
            <label htmlFor="car-number">Гос номер:</label>
            <input type="text" id="car-number" name="car-number" required />
          </div>
          <div>
            <label htmlFor="certificate">Сертификат:</label>
            <input 
              type="file" 
              id="certificate" 
              name="certificate" 
              accept=".pdf,.jpg,.jpeg,.png" 
              onChange={handleCertificateChange} 
              required 
            />
          </div>
          {certificatePreview && (
            <div className="certificate-preview">
              <img src={certificatePreview} alt="Certificate Preview" />
            </div>
          )}
          <button type="submit">Добавить</button>
          <button type="button" onClick={onClose}>Отмена</button>
        </form>
      </div>
    </div>
  );
};

export default AddModalVehicles;
